import React from "react";
import withDefaults from "../../../utils/with-defaults";

interface Props {
  count?: number;
  className?: string;
}

const defaultProps = {
  className: "",
};

type NativeAttrs = Omit<React.HTMLAttributes<any>, keyof Props>;
export type AvatarGroupProps = Props & typeof defaultProps & NativeAttrs;

const AvatarGroup: React.FC<React.PropsWithChildren<AvatarGroupProps>> = ({
  count,
  className,
  children,
}) => {
  return (
    <div className={`avatar-group flex items-center h-auto w-max ${className}`}>
      {children}
      {count && (
        <span className="text-sm inline-flex items-center text-gray-700 pl-1">
          +{count}
        </span>
      )}
    </div>
  );
};

export default withDefaults(AvatarGroup, defaultProps);
